module.exports = __webpack_public_path__ + "static/media/shoes.390e7546.jpg";